import {Component, Injector, OnInit} from '@angular/core';
import {BaseComponent} from '../../base.component';
import {FilterUtil} from '../../../util/filter.util';
import {RequestType} from '../../../enums/request.type';
import {ListResponse} from '../../../network/service/list.response';
import {SnackBarUtil} from '../../../util/snack.bar.util';
import {VerifyOptions} from '../../dialog/verify/options/verify.options';
import {VerifyComponent} from '../../dialog/verify/verify.component';
import {DataResponse} from '../../../network/service/data.response';
import {AddOrUpdateSettingsComponent} from '../dialog/add-or-update-settings/add-or-update-settings.component';
import {AddOrUpdateSettingsOptions} from '../dialog/add-or-update-settings/options/add-or-update-settings.options';

@Component({
  selector: 'app-settings',
  standalone: false,
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.scss'
})
export class SettingsComponent extends BaseComponent implements OnInit {
  displayedColumns = ['Update', 'Delete', 'Title', 'Branch', 'IsActive'];
  displayDataSources = ['edit', 'delete', 'Title', 'BusinessId', 'IsActiveIcon'];
  displayColumnTypes = ['event', 'event', 'string', 'business', 'icon'];
  displayEndPoint = ['', ''];
  settings: any = [];
  allFilters = FilterUtil.DeliveryMethodsFilters;
  filters: any = {};

  constructor(injector: Injector) {
    super(injector);
  }

  override ngOnInit() {
    super.ngOnInit();
  }

  override loadOnline() {
    super.loadOnline();
    this.serviceApi.getSettings(this.tableProperties.offset, this.tableProperties.limit, 'Business', RequestType.PAGINATE, undefined, {
      Filter: this.filters,
    }).subscribe((res: ListResponse<any>) => {
      if (res.success) {
        this.settings = res.data;
        this.tableProperties.pageLength = res.count;
        this.setListeners();
      } else {
        SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
      }
    });
  }

  override setListeners() {
    super.setListeners();
    if (this.settings) {
      for (let i = 0; i < this.settings.length; i++) {
        this.settings[i].edit = (index: number) => {
          this.onUpdateClicked(index);
        };
        this.settings[i].delete = (index: number) => {
          this.onDeleteClicked(index);
        };
        if (this.settings[i].IsActive === true) {
          this.settings[i].IsActiveIcon = 'check_circle-green';
        } else {
          this.settings[i].IsActiveIcon = 'do_not_disturb-red';
        }
      }
    }
  }

  override pageChanged(event: any) {
    super.pageChanged(event);
    this.tableProperties.offset = (event.pageIndex);
    this.loadOnline();
  }

  override onSortChanged(event: any) {
    super.onSortChanged(event);
    this.loadOnline();
  }

  onFiltersChanged(filters: any) {
    this.filters = filters;
    this.tableProperties.offset = 0;
    this.loadOnline();
  }

  onCreateClicked() {
    let addOrUpdateSettingOptions = new AddOrUpdateSettingsOptions();
    addOrUpdateSettingOptions.setting = {};
    addOrUpdateSettingOptions.onInsertOrUpdateFinished = () => {
      this.loadOnline();
    };
    let addOrUpdateSettingsComponent = this.matDialog.open(AddOrUpdateSettingsComponent, {
      height: 'auto',
      width: '100%',
      direction: "rtl"
    });
    addOrUpdateSettingsComponent.componentInstance.addOrUpdateSettingsOptions = addOrUpdateSettingOptions;
  }

  onUpdateClicked(index: number) {
    let addOrUpdateSettingOptions = new AddOrUpdateSettingsOptions();
    addOrUpdateSettingOptions.setting = this.settings[index];
    addOrUpdateSettingOptions.onInsertOrUpdateFinished = () => {
      this.loadOnline();
    };
    let addOrUpdateSettingsComponent = this.matDialog.open(AddOrUpdateSettingsComponent, {
      height: 'auto',
      width: '100%',
      direction: "rtl"
    });
    addOrUpdateSettingsComponent.componentInstance.addOrUpdateSettingsOptions = addOrUpdateSettingOptions;
  }

  onDeleteClicked(index: number) {
    let verifyOptions = new VerifyOptions();
    verifyOptions.message = 'آیا از حذف درخواست خود مطمئن هستید؟';
    let verifyComponent = this.matDialog.open(VerifyComponent);
    verifyOptions.onNoClicked = () => {
      verifyComponent.close();
    };
    verifyOptions.onYesClicked = () => {
      this.serviceApi.deleteSettings(this.settings[index].SettingId).subscribe((res: DataResponse<any>) => {
        if (res.success) {
          verifyComponent.close();
          this.loadOnline();
        } else {
          SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
        }
      });
    };
    verifyComponent.componentInstance.verifyOptions = verifyOptions;
  }
}
